// 企业微信相关URL
export const wwUnifiedOauthState = '/wxwork/unified-oauth-state'
export const wwGetAppInfo = '/wxwork/app-info'
export const wwGetUserInfo = '/wxwork/user-info'
export const wwGetAgentId = '/wxwork/get-agent-id'
export const wwSetUserActive = '/wxwork/set-user-active'
export const wwGetVerify = '/wxwork/get-verify'
export const wwBindUser = '/wxwork/user-bind'
export const wwGetUsers = '/wxwork/get-users'
export const wwGetCorpConfigSignature = '/wxwork/get-corp-config-signature'
export const wwGetAgentConfigSignature = '/wxwork/get-agent-config-signature'
export const wwGetExternalContact = '/wxwork/get-external-contact'
export const wwGetCppContact = '/customer/contact/wxwork-get'
export const wwkBindCppContact = '/customer/contact/wxwork-bind'
export const wwkGetCustomerTags = '/customer/customer/tags'
export const wwkGetCustomerOrders = '/customer/customer/orders'
// 获取客户群
export const wwGetExternalContactGroups = '/wxwork/get-external-contact-groups'
// 获取所有的企业标签
export const wwGetCorpTagList = '/wxwork/get-corp-tag'
// 设置企业标签
export const wwSetMarkTag = '/wxwork/set-mark-tag'
// 创建客户并绑定
export const wwCreateBindContact = '/customer/contact/wxwork-create-bind'



// WEBPACK FOOTER //
// ./src/api/url/wxwork.js